import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const { user, userApi } = useAuth();
  const [ids, setIds] = useState([]);

  useEffect(() => {
    if (!user) { setIds([]); return; }
    userApi.get("/account/wishlist/ids")
      .then(({ data }) => setIds(data.ids || []))
      .catch(() => {});
  }, [user, userApi]);

  const isWishlisted = useCallback((productId) => ids.includes(productId), [ids]);

  const toggle = useCallback(async (productId) => {
    if (!user) return { ok: false, needsLogin: true };
    const inList = ids.includes(productId);
    try {
      const { data } = inList
        ? await userApi.delete(`/account/wishlist/${productId}`)
        : await userApi.post(`/account/wishlist/${productId}`);
      setIds(data.ids || []);
      return { ok: true, added: !inList };
    } catch {
      return { ok: false };
    }
  }, [ids, user, userApi]);

  return (
    <WishlistContext.Provider value={{ ids, isWishlisted, toggle }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be used inside WishlistProvider");
  return ctx;
};
